import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted, provide, ref } from "vue";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useRoute } from "vue-router";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  PROVIDE_KEY_UPDATE_VOC_DETAIL,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import Modal from "@/components/shared/modal/base/Modal.vue";
import { useBbsStore } from "@/stores/bbsStore";
import VocEdit from "@/components/bbs/voc/VocEdit.vue";
import VocDetail from "@/components/bbs/voc/VocDetail.vue";
import router from "@/router";
import { IVocDetail } from "@/domain/entities/bbs";


const __default__ = {
  name: "Voc",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const route = useRoute();
const bbsStore = useBbsStore();

const createMode = ref(route.path.includes("/write")); // 문의하기 버튼을 눌러서 들어온 경우에만 true
const editMode = ref(createMode.value);

const handleClickBack = () => {
  if (createMode.value || !editMode.value) {
    router.back();
  } else {
    toggleEditMode(false);
  }
};

const vocUid = ref(route.params.uid?.toString()); // 문의하기 목록을 눌러서 들어온 경우에만 가지고 있음
const vocDetail = ref<IVocDetail>({} as IVocDetail);

const updateVocDetail = <K extends keyof IVocDetail>(
  key: K,
  value: IVocDetail[K]
) => {
  vocDetail.value[key] = value;
};
provide(PROVIDE_KEY_UPDATE_VOC_DETAIL, updateVocDetail);

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const toggleEditMode = (mode: boolean) => {
  editMode.value = mode;
};

const shouldShowAddressSearchMap = ref(false);
const toggleShowAddressSearchMap = (show: boolean) => {
  shouldShowAddressSearchMap.value = show;
};

const shouldShowDeleteConfirmModal = ref(false);
const toggleShowDeleteConfirmModal = (show: boolean) => {
  shouldShowDeleteConfirmModal.value = show;
};

const getVocDetail = async (uid: string) => {
  const result = await bbsStore.getVocDetail(uid);
  if (!result.isSuccess) {
    handleError("문의하기 상세 오류", result);
    return;
  }
  vocDetail.value = result.data ?? ({} as IVocDetail);
};

const deleteVocDetail = async () => {
  if (!vocDetail.value) return;

  const deleteResult = await bbsStore.deleteVocDetail(vocDetail.value.uid);

  if (deleteResult.isSuccess) {
    showToastMessage("문의하신 글이 삭제되었습니다");
    goToBack();
  } else {
    handleError("문의하기 삭제 오류", deleteResult);
  }
};

const goToBack = () => {
  router.currentRoute.value.meta.willGoBack = true;
  router.back();
};

onMounted(() => {
  if (vocUid.value) {
    getVocDetail(vocUid.value);
  }
});

const __returned__ = { showErrorModal, showToastMessage, route, bbsStore, createMode, editMode, handleClickBack, vocUid, vocDetail, updateVocDetail, handleError, toggleEditMode, shouldShowAddressSearchMap, toggleShowAddressSearchMap, shouldShowDeleteConfirmModal, toggleShowDeleteConfirmModal, getVocDetail, deleteVocDetail, goToBack, Page, NavigationBar, Modal, VocEdit, VocDetail }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})